export enum FoundSecretType {
    clippy,
    nyanCat,
    harlemShake,
    asciiCow,
    openDeeplyNestedSecretFile,
}